export default {
    LESS_THAN_ONE: 'less-1',
    ONE_TO_TWO: '1-2',
    TWO_TO_THREE: '2-3',
    THREE_TO_FOUR: '3-4',
    FOUR_TO_FIVE: '4-5',
    FIVE_TO_SIX: '5-6',
    SIX_TO_SEVEN: '6-7',
    SEVEN_TO_EIGHT: '7-8',
    EIGHT_TO_NINE: '8-9',
    NINE_TO_TEN: '9-10',
    TEN_TO_ELEVEN: '10-11',
    ELEVEN_TO_TWELVE: '11-12',
    TWELVE_TO_THIRTEEN: '12-13',
    THIRTEEN_TO_FOURTEEN: '13-14',
    FOURTEEN_TO_FIFTEEN: '14-15',
    FIFTEEN_TO_SIXTEEN: '15-16',
    SIXTEEN_TO_SEVENTEEN: '16-17',
    SEVENTEEN_TO_EIGHTEEN: '17-18',
    EIGHTEEN_TO_NINETEEN: '18-19',
    NINETEEN_TO_TWENTY: '19-20',
    TWENTY_TO_TWENTY_ONE: '20-21',
    TWENTY_ONE_TO_TWENTY_TWO: '21-22',
    TWENTY_TWO_TO_TWENTY_THREE: '22-23',
    TWENTY_THREE_TO_TWENTY_FOUR: '23-24',
    TWENTY_FOUR_TO_TWENTY_FIVE: '24-25',
    TWENTY_FIVE_PLUS: '25-plus',
};
